module.exports = __webpack_public_path__ + "static/images/saved-poi-home-icon.3LsW0OC.svg";